import { BrowserProvider, Contract, parseUnits } from 'ethers';

const ERC20_ABI = [
  'function transfer(address to, uint256 amount) returns (bool)',
];

function toChainIdHex(chainId) {
  return `0x${Number(chainId).toString(16)}`;
}

export async function ensureCorrectChain(chainId) {
  if (!window.ethereum) {
    throw new Error('ไม่พบ MetaMask');
  }

  const currentChainId = await window.ethereum.request({ method: 'eth_chainId' });
  const target = toChainIdHex(chainId);

  if (currentChainId?.toLowerCase() === target.toLowerCase()) {
    return;
  }

  await window.ethereum.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: target }],
  });
}

export async function sendUsdtTransfer({
  contractAddress,
  depositAddress,
  amount,
  decimals,
  chainId,
  minConfirmations = 1,
}) {
  if (!window.ethereum) {
    throw new Error('ไม่พบ MetaMask');
  }

  await ensureCorrectChain(chainId);

  const provider = new BrowserProvider(window.ethereum);
  const signer = await provider.getSigner();
  const contract = new Contract(contractAddress, ERC20_ABI, signer);
  const tx = await contract.transfer(
    depositAddress,
    parseUnits(String(amount), decimals)
  );
  const confirms = Math.max(1, Number(minConfirmations) || 1);
  const receipt = await tx.wait(confirms);
  return receipt.hash;
}

export function createMockTxHash() {
  const hex = Array.from({ length: 64 }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join('');
  return `0x${hex}`;
}
